import { ApiError } from '@gorila-shared-ui/components';
import { MapCurrentState } from '../types/currentState';
import { downloadRequest, getRequest } from './api';
import { mapCurrentStateUrl, publicMapCurrentStateUrl } from './urls/currentStateUrls';

export const getGeojsonFile = async (url: string): Promise<{ file?: Blob; error?: ApiError }> => {
  const response = await downloadRequest(url);

  return {
    file: response?.data?.file,
    error: response?.error,
  };
};

export const getMapCurrentStates = async (
  x0: number,
  y0: number,
  x1: number,
  y1: number,
  clientId: string,
  subClientId?: string,
): Promise<{ currentStates?: MapCurrentState[]; error?: ApiError }> => {
  const response = await getRequest(mapCurrentStateUrl, {
    queryParams: { clientId, subClientId, x0, y0, x1, y1 },
  });
  return {
    currentStates: response?.data,
    error: response?.error,
  };
};

export const getPublicMapCurrentStates = async ({
  x0,
  y0,
  x1,
  y1,
  shareLinkId,
}: {
  x0: number;
  y0: number;
  x1: number;
  y1: number;
  shareLinkId: string;
}): Promise<{ currentStates?: MapCurrentState[]; error?: ApiError }> => {
  const response = await getRequest(publicMapCurrentStateUrl(shareLinkId), {
    queryParams: { x0, y0, x1, y1 },
  });
  return {
    currentStates: response?.data,
    error: response?.error,
  };
};
